module.exports = __webpack_public_path__ + "static/img/David-Gillespie.e8c0b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Gillespie.jpg
// module id = DcUv
// module chunks = 0